<template>
  <div class="calendar">
    <sm-date-picker
      is-expanded
      :disabled-dates="
        [
          { weekdays: [1] },
          jadwalDirection.rangeOnDate != ''
            ? id_jenis == 'paid_online'
              ? {
                  start: idx == 1 ? this.jadwalDirection.rangeOnDate : null,
                  end: idx == 1 ? null : this.jadwalDirection.rangeOnDate,
                }
              : null
            : null,
        ].concat(unavailable)
      "
      :min-date="new Date()"
      :select-attribute="selectAttribute"
      @dayclick="onDayClick"
      v-model="date"
      is-required
    />
    <hr class="m-t-32" />
    <div class="jadwal-info">
      <div class="p-x-20">
        <div class="f-14 f-regular f-c-primary p-y-16">
          <label class="m-d-0 f-c-midgrey"> Jadwal Training </label>
        </div>
        <div class="f-18 f-regular">
          <p>
            {{ formatDisplay }}
          </p>
        </div>
      </div>
    </div>
    <div class="p-x-20">
      <button
        class="btn btn-primary btn-long"
        :disabled="!this.date"
        @click="handleButtonClick(id_jenis)"
      >
        Lanjutkan
      </button>
    </div>
    <template v-if="id_jenis != 'free_online'">
      <ModalJadwal ref="modaljadwal" :tanggal="date" :idx="idx"></ModalJadwal>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";
import ModalJadwal from "./ModalJadwal.vue";

export default {
  name: "Calendar",
  components: {
    ModalJadwal,
  },
  props: {
    id_jenis: "",
    idx: 0,
  },
  data() {
    return {
      unavailable: [],
      value: null,
      idjenis: "",
      tanggal_mulai: this.$moment(new Date()).format("YYYY-MM-DD"),
      tanggal_selesai: this.$moment(this.tanggal_mulai)
        .add(3, "M")
        .format("YYYY-MM-DD"),
      date: "",
      selectAttribute: {
        highlight: "green",
      },
    };
  },
  async mounted() {
    await this.init();
    await this.getDataDate();
  },

  computed: {
    ...mapGetters(moduleName, {
      formJadwal: "formJadwal",
      detailJenisTraining: "detailJenisTraining",
      jadwalUnavailable: "jadwalUnavailable",
      jadwalDirection: "jadwalDirection",
    }),
    formatPost() {
      if (this.date) {
        const formattedDate = this.$moment(this.date).format("YYYY-MM-DD");
        return `${formattedDate}`;
      }
    },
    formatTanggal() {
      return this.$moment(this.date).format("YYYY-MM-DD");
    },
    formatDisplay() {
      if (this.id_jenis === "free_online") {
        if (this.date) {
          const formattedDate = this.$moment(this.date).format("DD MMMM YYYY");
          return `${formattedDate} 13:00 - 13:45`;
        } else {
          return "Belum Dipilih";
        }
      } else {
        const jadwalMulai =
          this.formJadwal.jadwal_training[this.idx - 1].jadwal_mulai;
        const jadwalSelesai =
          this.formJadwal.jadwal_training[this.idx - 1].jadwal_selesai;

        if (jadwalMulai !== "" && jadwalSelesai !== "") {
          const formattedMulai = this.$moment(
            this.formJadwal.jadwal_training[this.idx - 1].jadwal_mulai
          ).format("DD MMMM YYYY HH:mm");
          const formattedSelesai = this.$moment(
            this.formJadwal.jadwal_training[this.idx - 1].jadwal_selesai
          ).format("HH:mm");
          return `${formattedMulai} - ${formattedSelesai}`;
        } else {
          return "Belum Dipilih";
        }
      }
    },
  },
  created() {
    if (this.formJadwal) {
      if (this.formJadwal.jadwal_training[this.idx - 1].jadwal_mulai) {
        this.date = this.formJadwal.jadwal_training[this.idx - 1].jadwal_mulai;
      }
    }
  },
  methods: {
    ...mapActions({
      getDetailJenisTraining: `${moduleName}/getDetailJenisTraining`,
      getListJenisExist: `${moduleName}/getListJenisExist`,
      getJadwalUnavailable: `${moduleName}/getJadwalUnavailable`,
    }),
    async init() {
      let params_idJenis = this.$route.params.idjenis;
      await this.getDetailJenisTraining(params_idJenis);
      let data = {
        idjenis: params_idJenis,
        tanggal_mulai: this.tanggal_mulai,
        tanggal_selesai: this.$moment(this.tanggal_mulai)
          .add(3, "M")
          .format("YYYY-MM-DD"),
      };
      await this.getJadwalUnavailable(data);
    },

    getDataDate() {
      for (let i = 0; i < this.jadwalUnavailable.length; i++) {
        let formatDate = this.$moment(this.jadwalUnavailable[i].tanggal).format(
          "YYYY-MM-DD"
        );
        this.unavailable.push(formatDate);
      }
      this.unavailable.push(this.$moment("2023-12-25").format(
          "YYYY-MM-DD"
      ));
      this.unavailable.push(this.$moment("2023-12-26").format(
          "YYYY-MM-DD"
      ));
      this.unavailable.push(this.$moment("2024-01-01").format(
          "YYYY-MM-DD"
      ));
    },
    async onDayClick() {
      if (this.id_jenis == "free_online") {
        this.formJadwal.jadwal_training[0].jadwal_mulai =
          this.$moment(this.date).format("YYYY-MM-DD") + " 13:00:00";
        this.formJadwal.jadwal_training[0].jadwal_selesai =
          this.$moment(this.date).format("YYYY-MM-DD") + " 13:45:00";
        this.formJadwal.jadwal_training[0].sesi = 1;
      }
      this.$refs.modaljadwal.open();
      let Data = {
        idjenis: this.$route.params.idjenis,
        date: this.formatTanggal,
      };
      await this.getListJenisExist(Data);
    },
    handleButtonClick(param_idjenis) {
      if (this.idx == 1) {
        this.formJadwal.jadwal_training[0].sesi = this.idx;
      }
      if (this.idx == 2) {
        this.formJadwal.jadwal_training[1].sesi = this.idx;
      }
      this.$router.push({
        name: "training.create",
        params: { idjenis: param_idjenis },
      });
    },
  },
};
</script>
